import Home from "./Pages/Home/Home";
import Profile from "./Pages/Profile/Profile";
import Login from "./Pages/Login/Login";
import Register from "./Pages/Register/Registe";

function App() {
  return (
    <div>
      <Home />
      {/* <Profile /> */}
      {/* <Login /> */}
      {/* <Register /> */}
    </div>
  );
}

export default App;
